import { styled } from '@mui/material/styles';
import { SparkleIcon as PhosphorSparkleIcon } from '@phosphor-icons/react/Sparkle';

const SPARKLE_ICON_ID = 'rbo-gradient';

const StyledSparkle = styled(PhosphorSparkleIcon)({ fill: `url(#${SPARKLE_ICON_ID})` });

export const SparkleIcon = () => {
  return (
    <>
      <svg width="0" height="0" style={{ position: 'absolute' }}>
        <defs>
          <linearGradient id={SPARKLE_ICON_ID} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="18.08%" stopColor={'#EFCCBB'} />
            <stop offset="99.11%" stopColor={'#B18572'} />
          </linearGradient>
        </defs>
      </svg>
      <StyledSparkle size={24} />
    </>
  );
};
